import React from 'react';

const Swirl = () => {
    return (
        <svg className='swirl' width="100%" height="24px" fill="none" preserveAspectRatio="none" viewBox="0 0 1440 14">
            <path className='color' d="M0 14C39.9998 -24.6212 1400 38.621 1440 0V14L0 14Z" fill="#003019"/>
        </svg>
    )
}
export default Swirl